export const en = {
  "common": {
    "save": "Save",
    "cancel": "Cancel",
    "add": "Add",
    "delete": "Delete",
    "close": "Close",
    "edit": "Edit",
    "reset": "Reset",
    "search": "Search",
    "loading": "Loading...",
    "saving": "Saving...",
    "ready": "Ready",
    "synced": "Synced",
    "syncError": "Sync Error",
    "cards": "cards",
    "sets": "Sets",
    "shining": "shining",
    "all": "All",
    "remove": "Remove",
    "confirm": "Confirm",
    "success": "Success",
    "error": "Error",
    "optional": "Optional"
  },
  "nav": {
    "pokedex": "Pokédex",
    "nationalDex": "National Dex",
    "decks": "Decks",
    "rules": "Rules",
    "profile": "Settings",
    "signIn": "Sign In",
    "signOut": "Sign Out",
    "whitelisted": "Whitelisted",
    "trainer": "Trainer",
    "guestVisitor": "Guest Visitor",
    "opticalSensor": "Pokédex Optical Sensor",
    "enableSounds": "Enable sounds",
    "muteSounds": "Mute sounds",
    "version": "v1.0"
  },
  "preferences": {
    "title": "User Preferences",
    "subtitle": "Personalize your interface language, sound effects and app experience",
    "languageLabel": "Language / Idioma",
    "languagePt": "Português (BR)",
    "languageEn": "English",
    "languageSavedNotice": "Your language preference is saved in your browser and automatically restored when you return.",
    "soundLabel": "Sound Effects",
    "soundEnabled": "Sound Enabled",
    "soundEnabledDesc": "8-bit Pokédex audio chirps on clicks and actions",
    "soundMuted": "Muted / Silent",
    "soundMutedDesc": "All sound effects and audio chirps silenced",
    "soundSavedNotice": "Your sound preference is saved in your browser and automatically restored when you return."
  },
  "pokedex": {
    "title": "Card Database & Pokédex",
    "subtitle": "{count} cards matched in the active collection",
    "addCardsBtn": "Add Cards / Import CSV",
    "totalOwned": "Total Owned",
    "uniqueRegistered": "Unique Registered",
    "foilHolo": "Foil / Holo",
    "completion": "Completion",
    "noCardsFound": "No Cards Found",
    "noCardsFoundDesc": "Try adjusting your filters or search terms."
  },
  "filters": {
    "searchPlaceholder": "Search by name (Charizard, Darkrai), card # (#88), set code...",
    "clearSearch": "Clear search",
    "allCategories": "All Categories",
    "pokemonOnly": "Pokémon Only",
    "trainersOnly": "Trainers Only",
    "energiesOnly": "Energies Only",
    "allSets": "All Sets",
    "sortBy": "Sort by",
    "sortCardNum": "Card #",
    "sortName": "Name (A-Z)",
    "sortQuantity": "Quantity",
    "sortRarity": "Rarity",
    "resetFilters": "Reset",
    "foilOnly": "Foil / Holo Only",
    "mappedInDecks": "Mapped in Decks",
    "ownedOnly": "Owned (Qty > 0)",
    "duplicatesOnly": "Duplicates (>1)",
    "missingOnly": "Missing (Qty = 0)",
    "types": {
      "ALL": "All Types",
      "grass": "Grass",
      "fire": "Fire",
      "water": "Water",
      "lightning": "Lightning",
      "psychic": "Psychic",
      "fighting": "Fighting",
      "darkness": "Darkness",
      "metal": "Metal",
      "fairy": "Fairy",
      "dragon": "Dragon",
      "colorless": "Colorless",
      "trainer": "Trainer",
      "energy": "Energy"
    }
  },
  "cardItem": {
    "removeFavorite": "Remove from favorites",
    "addFavorite": "Add to favorites",
    "deckPrefix": "D"
  },
  "cardDetail": {
    "titlePrefix": "Pokédex Data //",
    "favorite": "Favorite",
    "addToFavs": "Add to Favs",
    "qty": "Qty:",
    "removeCard": "Remove this card from collection",
    "confirmDelete": "Remove \"{name}\" from collection?",
    "expansionSet": "Expansion Set:",
    "setCode": "Set Code:",
    "cardNumber": "Card Number:",
    "rarity": "Rarity:",
    "condition": "Condition:",
    "language": "Language:",
    "addToDeck": "Add to Deck:",
    "added": "Added!",
    "addBtn": "Add",
    "featuredInDecks": "Featured in Decks:",
    "personalNotes": "Personal Notes:",
    "saved": "Saved!",
    "notesPlaceholder": "Ex: Turn 1 combo with Mewtwo & Mew-GX, save for late-game...",
    "saveCardNote": "Save Card Note",
    "foilHolo": "Foil / Holo",
    "priceSectionTitle": "Market & Collection Value",
    "priceLabel": "Card Value ($)",
    "pricePlaceholder": "Ex: 25.00 or 150.50",
    "priceUpdatedLabel": "Update Date",
    "savePrice": "Save Value",
    "priceSaved": "Value saved!",
    "deckCardToggle": "Deck Card for this Pokémon",
    "deckCardActive": "This is the chosen card for this Pokémon in the deck",
    "deckCardInactive": "Not selected for deck"
  },
  "decks": {
    "title": "Tactical Deck Builder",
    "subtitle": "Manage your 60-card decks, turn-by-turn playbooks, and energy ratios",
    "cardsCount": "{count}-Card Deck",
    "exportLive": "Export (PTCG Live)",
    "decklistCopied": "Decklist Copied!",
    "editDeckBtn": "Edit Deck & Playbook",
    "deleteDeck": "Delete Deck",
    "confirmDelete": "Are you sure you want to delete deck \"{name}\"?",
    "createDeck": "Create New Deck",
    "validateDeck": "Validate Deck (CSV)",
    "composition": "Composition ({count} Cards)",
    "pokemonCount": "{count} Pokémon",
    "trainersCount": "{count} Trainers",
    "energiesCount": "{count} Energy",
    "energyBreakdown": "Energy Breakdown",
    "energyRequired": "Required: {needed}",
    "energyComplete": "Energy complete!",
    "winCondition": "Win Condition",
    "playbook": "Strategic Turn Playbook",
    "opening": "1. Opening",
    "midgame": "2. Midgame",
    "endgame": "3. Endgame",
    "customizePlaybook": "Customize Playbook",
    "prizeTradeTip": "Prize Trade Tip:",
    "completeList": "Complete Deck Card List",
    "pokemonSection": "Pokémon ({count})",
    "trainersSection": "Trainers ({count})",
    "energySection": "Energy ({count})",
    "owned": "Owned: {count}",
    "missing": "Missing",
    "removeFromDeck": "Remove from deck"
  },
  "editDeck": {
    "title": "Edit Deck & Strategic Playbook",
    "tabPlaybook": "Strategic Turn Playbook",
    "tabDetails": "Deck Details & Theme",
    "winConditionLabel": "Win Condition & Primary Goal",
    "winConditionPlaceholder": "Ex: Take 6 Prize Cards by cycling Energy with Malamar to power up Necrozma Special Laser attack.",
    "prizeTradeLabel": "Prize Trade Tip",
    "prizeTradePlaceholder": "Ex: Aim to trade 1-Prize attackers efficiently against opponent 2-Prize Pokémon-GX/V.",
    "openingPlan": "1. Opening / Early Game Plan",
    "midgamePlan": "2. Midgame Strategy",
    "endgamePlan": "3. Endgame / Closing Plan",
    "defaultOpeningTitle": "1. Opening Plan (Turns 1 & 2)",
    "defaultMidgameTitle": "2. Midgame Plan (Turns 3 to 5)",
    "defaultEndgameTitle": "3. Endgame Plan",
    "addStep": "Add Step",
    "sectionTitlePlaceholder": "Section title (e.g. 1. Opening Plan)...",
    "stepPlaceholder": "Step {num} instructions...",
    "deckName": "Deck Name *",
    "namePlaceholder": "Ex: Necrozma (Laser Focus)",
    "archetype": "Archetype",
    "archetypePlaceholder": "Ex: Psychic Toolbox / Malamar Turbo",
    "format": "Format",
    "formatStandard": "Standard",
    "formatExpanded": "Expanded",
    "formatCasual": "Casual",
    "accentColor": "Accent Color & Glow",
    "summary": "Deck Summary",
    "summaryPlaceholder": "Brief strategy overview of how this deck operates...",
    "saveChanges": "Save Changes"
  },
  "createDeck": {
    "title": "Create New Deck (Deck Builder)",
    "deckName": "Deck Name *",
    "namePlaceholder": "Ex: Gardevoir Psychic Turbo",
    "format": "Format",
    "formatStandard": "Standard",
    "formatExpanded": "Expanded",
    "formatCasual": "Casual",
    "archetype": "Archetype",
    "archetypePlaceholder": "Ex: Aggro, Control, OHKO, Toolbox",
    "winCondition": "Win Condition",
    "winConditionPlaceholder": "Ex: High Turn 2 burst damage with energy acceleration",
    "cardsCount": "{current} / 60 Cards",
    "pokemonCount": "{count} Pokémon",
    "trainersCount": "{count} Trainers",
    "energiesCount": "{count} Energies",
    "fullDeck": "Full Deck!",
    "cardsLeft": "{count} left",
    "excessCards": "{count} excess",
    "addCardsCollection": "Add Cards from Collection:",
    "searchCardsPlaceholder": "Search collection by name or type...",
    "add": "Add",
    "cardsInDeck": "Cards in Deck ({count} types):",
    "saveDeck": "Save Deck"
  },
  "addCard": {
    "title": "Add Cards to Collection",
    "tabManual": "Manual Form",
    "tabCsv": "Batch CSV Import",
    "tabValidate": "Validate Deck (CSV)",
    "quickSearchLabel": "⚡ Smart Autofill (Name + Card # / Total)",
    "quickSearchPlaceholder": "Ex: Charizard 10/78, Mewtwo 81/182, Ultra Bola 196...",
    "quickSearchBtn": "Autofill",
    "quickSearchSearching": "Searching TCG database...",
    "quickSearchSuccess": "Card \"{name}\" ({set} #{num}) autofilled successfully!",
    "quickSearchNotFound": "No card found for \"{query}\". Please check name/number or fill manually.",
    "quickSearchSelectPrompt": "Found {count} editions. Click one to autofill:",
    "nameEn": "Card Name (English) *",
    "nameEnPlaceholder": "Ex: Charizard ex",
    "namePt": "Card Name (Portuguese / Alias)",
    "namePtPlaceholder": "Ex: Charizard ex",
    "setCode": "Set Code *",
    "setCodePlaceholder": "Ex: SVI, PAF, OBF",
    "cardNumber": "Card # *",
    "cardNumberPlaceholder": "Ex: 054 or 125",
    "totalInSet": "Total in Set",
    "totalInSetPlaceholder": "Ex: 198",
    "typeCategory": "Type / Category",
    "rarity": "Rarity",
    "rarityCommon": "Common (C)",
    "rarityUncommon": "Uncommon (U)",
    "rarityRare": "Rare (R)",
    "rarityRareHolo": "Rare Holo (RH)",
    "rarityUltraRare": "Ultra Rare (RU/GX)",
    "rarityDoubleRare": "Double Rare (RD/ex)",
    "rarityIllustrationRare": "Illustration Rare (IR)",
    "raritySecretRare": "Secret Rare (S)",
    "quantity": "Quantity",
    "imageSectionTitle": "Card Image & Cloud Storage Upload",
    "imageOptionA": "Option A: Upload Image File",
    "imageOptionB": "Option B: External Image URL",
    "imageReadyNotice": "Image ready to upload to Cloud Storage on save",
    "isFoil": "Holographic (Foil / Holo) Card",
    "uploadingAndSaving": "Uploading Image to Storage & Saving...",
    "saveCardBtn": "Save Card to Collection & Storage",
    "csvHelp": "Paste spreadsheet or CSV text (Pokemon TCG / LigaPokemon format), or upload a .csv file from your computer:",
    "deckAssignment": "Deck Assignment:",
    "deckModeNone": "Collection Only",
    "deckModeExisting": "Existing Deck",
    "deckModeNew": "+ New Deck",
    "selectExistingDeck": "Select Existing Deck:",
    "newDeckName": "New Deck Name *",
    "newDeckNamePlaceholder": "Ex: Malamar Necrozma Turbo",
    "format": "Format",
    "importSuccess": "Import finished: {added} added, {updated} updated",
    "importAndCreateDeck": "Import & Create Deck \"{name}\"",
    "importAndAddToDeck": "Import & Add to Existing Deck",
    "processCsv": "Process CSV Import",
    "cardAddedSuccessTitle": "Card Added Successfully!",
    "cardAddedSuccessDesc": "The card has been registered to your catalog and synced to Pokédex.",
    "cardUpdatedSuccessTitle": "Duplicate Card - Quantity Updated!",
    "cardUpdatedSuccessDesc": "This card already existed in your collection. Its quantity was updated to x{count} without creating a duplicate entry.",
    "addAnotherCard": "+ Add Another Card",
    "finishBtn": "Done & Close"
  },
  "validator": {
    "title": "Deck Validator (CSV vs Collection)",
    "subtitle": "Check which cards and quantities you own, and what is missing to build this deck without modifying your collection",
    "uploadHelp": "Upload a deck CSV file or paste spreadsheet text in the LigaPokémon / Pokémon TCG format:",
    "validateBtn": "Validate Deck Against Collection",
    "validating": "Analyzing Cards...",
    "newValidation": "New Validation",
    "deckHealth": "Deck Availability Status",
    "deckComplete": "Deck 100% Ready to Build!",
    "deckCompleteDesc": "Your collection contains all {total} cards required for this deck.",
    "deckIncomplete": "Missing Cards to Build Deck",
    "deckIncompleteDesc": "You have {owned} of {total} cards ({percent}%). You need {missing} more card(s).",
    "totalInDeck": "Total in Deck",
    "inCollection": "In Collection",
    "missingCount": "Missing Cards",
    "readiness": "Readiness",
    "filterAll": "All ({count})",
    "filterMissing": "Missing Only ({count})",
    "filterComplete": "Complete ({count})",
    "needed": "Needed",
    "owned": "Owned",
    "missing": "Missing {count}",
    "complete": "Complete ({owned}/{needed})",
    "surplus": "Surplus (+{count})",
    "inOtherEditions": "{count} in other sets",
    "copyMissingList": "Copy Missing List",
    "copied": "Missing List Copied!",
    "noMissing": "Great news! You have every single card needed to build this deck.",
    "noCardsParsed": "No valid cards could be parsed from the CSV. Please verify the format.",
    "similarCardsTitle": "Similar / Substitute Cards in Collection ({count})",
    "useAsSubstitute": "Use as Substitute",
    "substituteAssigned": "Substituted with {name}",
    "removeSubstitute": "Remove Substitute",
    "searchSubstitutePlaceholder": "Search collection for other substitutes...",
    "noSimilarFound": "No automatic substitutes found in collection.",
    "readinessWithSubstitutes": "Readiness with substitutes: {percent}% ({count}/{total})",
    "substitutesCount": "{count} substitute(s) assigned"
  },
  "profile": {
    "title": "Trainer Profile & Cloud Sync",
    "cloudSync": "Real-Time Cloud Firestore Sync",
    "cloudSyncDesc": "Continuous auto-save for cards, quantities, custom decks & notes",
    "totalOwned": "Total Owned",
    "customDecks": "Custom Decks",
    "favorites": "Favorites",
    "lastCloudSync": "Last Cloud Sync",
    "syncExplanation": "Every change you make (adjusting card quantities, building decks, adding favorites) is automatically persisted in real-time to your private Cloud Firestore collection.",
    "forceSync": "Force Sync Now",
    "syncing": "Syncing...",
    "whitelistWarning": "Your email is not in VITE_ALLOWED_EMAILS. Add it to .env to enable real-time Cloud Firestore synchronization.",
    "whitelistedEmails": "Authorized Whitelisted Emails (VITE_ALLOWED_EMAILS)",
    "whitelistDesc": "Only authenticated users whose email address appears in this list are authorized to sync and persist changes to the cloud database.",
    "noEmailsConfigured": "No emails configured (open development mode).",
    "storagePipeline": "Firebase Storage Image Pipeline",
    "storagePipelineDesc": "Cards automatically resolve high-resolution images from official CDNs or your private Firebase Storage bucket configured in .env.",
    "setsSyncTitle": "TCG Sets Metadata Sync",
    "setsSyncDesc": "Updates official expansion metadata (years, codes and regulation marks) from TCGdex API & Cloud Firestore",
    "setsCataloged": "Cataloged Sets",
    "lastSetsSync": "Last Sets Sync",
    "syncSetsBtn": "Sync TCG Sets Now",
    "syncingSets": "Fetching Sets from API...",
    "setsSyncSuccess": "{total} sets synced successfully!",
    "setsSyncExplanation": "Fetches all Pokémon TCG expansions from the official open API, calculates release years and competitive regulation mark rotation letters (D, E, F, G, H, I, J...), and saves configuration to Firebase.",
    "shareTitle": "Collection Sharing (Read-Only Visitor Link)",
    "shareDesc": "Allow another user to view your cards and decks safely via a secret link without logging into your account",
    "shareActiveBadge": "Link Active",
    "shareInactiveBadge": "Disabled",
    "shareLinkLabel": "Secret Read-Only Share Link",
    "shareGenerateBtn": "Generate Share Link",
    "generateLinkBtn": "Generate Share Link",
    "generatingLink": "Generating Link...",
    "shareRotateBtn": "Generate New Link",
    "rotateLinkBtn": "Generate New Link",
    "shareRevokeBtn": "Revoke Access",
    "revokeLinkBtn": "Revoke Access",
    "revokingLink": "Revoking Access...",
    "shareCopyBtn": "Copy Link",
    "copyLinkBtn": "Copy Link",
    "shareCopiedBtn": "Link Copied!",
    "linkCopied": "Link Copied!",
    "shareRotatedNotice": "New secret link generated! The previous link has been invalidated.",
    "shareRevokedNotice": "Shared access revoked! The link is no longer active.",
    "shareExplanation": "Anyone with this secret link can browse your cards and decks in Read-Only mode. They cannot add, edit, or delete anything. Revoking or generating a new link immediately invalidates the previous link.",
    "shareConfirmRevoke": "Revoke the current share link? Anyone using it will immediately lose access.",
    "shareConfirmRotate": "Generate a new link? The previous link will stop working immediately.",
    "visitorBadge": "Read-Only Visitor Mode",
    "visitorModeTitle": "Read-Only Visitor Mode",
    "visitorModeDesc": "You are viewing the shared collection of {owner}. Modifications are disabled to protect the owner's cards.",
    "visitorBannerText": "Read-Only Mode • Collection of {owner}",
    "exitVisitorBtn": "Exit Visitor Mode",
    "versionTitle": "System Version & PWA Updates",
    "versionSubtitle": "Compiled release tracking, cache purging and PWA update management",
    "installedVersion": "Installed Version",
    "buildNumber": "Build",
    "buildTime": "Build Date",
    "statusUpToDate": "App Up to Date",
    "statusUpdateAvailable": "New Version Available",
    "checkUpdatesBtn": "Check for Updates",
    "checkingUpdates": "Checking...",
    "forceUpdateBtn": "Force Reload & Purge PWA Cache",
    "pwaHelp": "If you installed this app on your phone as a PWA and screens are not updating, click 'Force Reload'. This unregisters service workers, deletes CacheStorage, and downloads the latest build from the servers.",
    "updateBannerText": "New version {version} is available!",
    "updateBannerBtn": "Update Now"
  },
  "accessGate": {
    "booting": "Booting Pokédex OS...",
    "verifying": "Verifying trainer credentials",
    "accessDenied": "Access Denied",
    "unauthorizedAccount": "Unauthorized Account",
    "accountNotAuthorized": "Account Not Authorized",
    "notAuthorizedDesc": "You are signed in as {email}, but this email address is not authorized to access this Pokédex.",
    "signedInAs": "You are signed in as {email}, but this email address is not authorized to access this Pokédex.",
    "signInAnother": "Sign In with Another Account",
    "signInTitle": "Sign In",
    "welcomeDesc": "Sign in with your authorized Google account to access your Pokémon collection and decks.",
    "signInGoogle": "Sign In with Google (Gmail)",
    "authError": "Authentication Error",
    "invalidShareTitle": "Invalid or Revoked Link",
    "invalidShareDesc": "This shared collection link is no longer active or was revoked by the trainer.",
    "goToLoginBtn": "Go to Sign In",
    "versionTitle": "System Version & PWA Updates",
    "versiontitle": "System Version & PWA Updates",
    "versionSubtitle": "Compiled release tracking, cache purging and PWA update management",
    "versionsubtitle": "Compiled release tracking, cache purging and PWA update management",
    "installedVersion": "Installed Version",
    "installedversion": "Installed Version",
    "buildNumber": "Build",
    "buildnumber": "Build",
    "buildTime": "Build Date",
    "buildtime": "Build Date",
    "statusUpToDate": "App Up to Date",
    "statusuptodate": "App Up to Date",
    "statusUpdateAvailable": "New Version Available",
    "statusupdateavailable": "New Version Available",
    "checkUpdatesBtn": "Check for Updates",
    "checkupdatesbtn": "Check for Updates",
    "checkingUpdates": "Checking...",
    "checkingupdates": "Checking...",
    "forceUpdateBtn": "Force Reload & Purge PWA Cache",
    "forceupdatebtn": "Force Reload & Purge PWA Cache",
    "pwaHelp": "If you installed this app on your phone as a PWA and screens are not updating, click 'Force Reload'. This unregisters service workers, deletes CacheStorage, and downloads the latest build from the servers.",
    "pwahelp": "If you installed this app on your phone as a PWA and screens are not updating, click 'Force Reload'. This unregisters service workers, deletes CacheStorage, and downloads the latest build from the servers.",
    "updateBannerText": "New version {version} is available!",
    "updatebannertext": "New version {version} is available!",
    "updateBannerBtn": "Update Now",
    "updatebannerbtn": "Update Now"
  },
  "rules": {
    "title": "Rules, Types & Battle Formats",
    "subtitle": "Complete guide to Pokémon TCG elemental types, competitive formats, trainer cards, and status conditions",
    "tabTypes": "11 Elemental Types",
    "tabFormats": "Formats & Rules",
    "tabTrainers": "Trainer Cards",
    "tabConditions": "Special Conditions",
    "tabSets": "TCG Expansions",
    "setsTitle": "Official Pokémon TCG Expansions & Sets",
    "setsSubtitle": "Browse release years, competitive regulation marks (letters), and format legality of each expansion",
    "searchSetsPlaceholder": "Search by name (Pitch Black, Brilliant Stars), code (ME05, SSP) or year...",
    "allEras": "All Eras / Marks",
    "markFilter": "Mark {mark} ({year})",
    "classicFilter": "Classic / No Mark (1999-2019)",
    "officialCode": "Code",
    "regulationMark": "Regulation Mark",
    "releaseYear": "Release Year",
    "totalCardsInSet": "{count} cards",
    "formatStandard": "Standard Format",
    "formatExpanded": "Expanded Format",
    "formatVintage": "Classic / Vintage",
    "noSetsFound": "No sets found matching these filters",
    "syncSetsListBtn": "Sync Expansions from API",
    "strengthsTitle": "Elemental Strengths & Type Matchups",
    "weakness": "Weakness",
    "resistance": "Resistance",
    "superEffective": "Super Effective Against (Attacking Advantages)",
    "deckSize": "Deck Size",
    "cardLimit": "Copy Limit",
    "sampleCard": "Featured Exemplar Card",
    "examples": "Examples",
    "statusEffect": "Status Condition",
    "effect": "Effect",
    "howToCure": "How to Cure",
    "archetypeStrengths": "Archetype Strengths & Signature Mechanics",
    "iconicCards": "Representative Iconic Cards",
    "coreRules": "Core Rules for Building Decks",
    "competitiveFormats": "Competitive & Casual Formats",
    "prizeCards": "Prize Cards",
    "clearFilters": "Clear filters",
    "classicBadge": "Classic",
    "markOptionJ": "Mark [J] (2025/2026 - Standard)",
    "markOptionI": "Mark [I] (2025 - Standard)",
    "markOptionH": "Mark [H] (2024 - Standard)",
    "markOptionG": "Mark [G] (2023 - Standard)",
    "markOptionF": "Mark [F] (2022 - Expanded)",
    "markOptionE": "Mark [E] (2021 - Expanded)",
    "markOptionD": "Mark [D] (2020 - Expanded)",
    "tabRarities": "Card Rarities",
    "raritiesTitle": "Official Card Rarities & Booster Pull Rates",
    "raritiesSubtitle": "Identify rarity symbols, official names, booster pull rates, and reference sets",
    "rarityPullRate": "Booster Pull Rate",
    "raritySymbol": "Symbol",
    "rarityReference": "Reference Expansion",
    "searchRaritiesPlaceholder": "Search by rarity name, code, or pull rate...",
    "syncRaritiesBtn": "Sync Rarities",
    "syncingRarities": "Syncing Rarities...",
    "noRaritiesFound": "No rarities found matching this search"
  },
  "pagination": {
    "pageInfo": "Page {current} of {total}",
    "prev": "Previous Page",
    "next": "Next Page"
  },
  "nationalDex": {
    "title": "National Pokédex (1025 Pokémon)",
    "subtitle": "Complete catalog of all 1025 Pokémon across all generations",
    "obtained": "Pokémon Obtained",
    "missing": "Missing",
    "total": "Total Cataloged",
    "completion": "National Completion",
    "filterAll": "All (1025)",
    "filterOwned": "Owned ({count})",
    "filterMissing": "Missing ({count})",
    "searchPlaceholder": "Search by name or number (#0025)...",
    "allGenerations": "All Generations",
    "genLabel": "Gen {gen}",
    "allTypes": "All Types",
    "sortBy": "Sort",
    "sortNumberAsc": "Number Ascending (#0001 → #1025)",
    "sortNumberDesc": "Number Descending (#1025 → #0001)",
    "sortNameAsc": "Name (A-Z)",
    "sortOwnedFirst": "Owned First",
    "cardsOwnedCount": "{count} cards",
    "copiesCount": "{count} copies",
    "statusOwned": "Owned",
    "statusMissing": "Not Owned",
    "modalTitle": "{name} Cards",
    "modalOwnedSummary": "You have {cardCount} different card(s) of this Pokémon ({copyCount} total copies)",
    "modalEmptyTitle": "No Cards Found",
    "modalEmptyDesc": "You don't have any cards of {name} in your TCG collection yet.",
    "addCardForThis": "Add card for {name}",
    "viewCardDetails": "View card details",
    "loadMore": "Load More Pokémon",
    "showingCount": "Showing {count} of {total} Pokémon",
    "totalCardsInCollection": "TCG Pokémon Cards",
    "kanto": "Kanto",
    "johto": "Johto",
    "hoenn": "Hoenn",
    "sinnoh": "Sinnoh",
    "unova": "Unova",
    "kalos": "Kalos",
    "alola": "Alola",
    "galar": "Galar",
    "paldea": "Paldea",
    "deckValue": "Deck Value",
    "deckValuedPokemons": "{count} valued Pokémon",
    "deckSelectedCount": "{count} in deck",
    "filterDeck": "In Deck ({count})",
    "deckCard": "Deck Card",
    "selectForDeck": "Select for Deck",
    "removeFromDeck": "Remove from Deck",
    "chosenDeckCard": "Chosen Deck Card",
    "noDeckCard": "No card chosen for deck",
    "price": "Value",
    "updatedAt": "Updated at",
    "noPrice": "No value set"
  }
} as const;

type DeepStringRecord<T> = {
  [K in keyof T]: T[K] extends string ? string : DeepStringRecord<T[K]>;
};

export type TranslationKeys = DeepStringRecord<typeof en>;

